import React, { Component } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { withRouter, Switch, Route } from 'react-router-dom'
import { withReactGA } from 'common/components'

// Components
import PatientLayout from './PatientLayout'
import PatientSingleLayout from './PatientSingleLayout'
import SettingsLayout from './SettingsLayout'
import ReportsLayout from './ReportsLayout'
import ReportsRideDataLayout from './ReportsRideDataLayout'
import LeaderboardLayout from './LeaderboardLayout'

import '../styles/index.scss'
import '../styles/navigation.scss'
import 'common/styles/index.scss'
import { authenticate, getLegal, acceptLegal } from 'common/actions'
import TabBar from './TabBar'
import Legal from 'common/components/Legal'
import Login from './Login'
import SnackBar from './SnackBar'

import { getAnnouncements } from '../actions'
import AnnouncementLayout from './AnnouncementLayout'

const mapStateToProps = ({ status: { isLoading }, currentUser, currentLegal, announcements }) => {
  return {
    isLoading,
    currentUser: currentUser,
    currentLegal: currentLegal,
    isAuthenticated: !!currentUser._id,
    isTherapist: currentUser.roles && (currentUser.roles.includes('therapist') || currentUser.roles.includes('administrator')),
    announcements,
  }
}
const mapDispatchToProps = {
  authenticate,
  getAnnouncements,
  getLegal,
  acceptLegal
}

class App extends Component {
  async componentDidMount () {
    await this.props.authenticate()
    await this.props.getLegal()
    await this.props.getAnnouncements()
  }

  acceptLegal = async () => {
    await this.props.acceptLegal(this.props.currentUser._id, this.props.currentLegal._id)
  }

  onSwipe = index => {
    if (index === this.props.announcements.length) {
      this.setState({ announcementsVisible: false })
      setTimeout(() => {
        this.setState({ activeAnnouncements: 0 })
      }, 800)
    }
    else {
      this.setState({ activeAnnouncements: index })
    }
  }

  render () {
    const { currentUser, currentLegal } = this.props
    // Show nothing if we're still loading
    if (this.props.isLoading) {
      return null
    }

    // Show the login component if we aren't authenticated
    if (!this.props.isAuthenticated) {
      return (<Login />)
    }

    return (
      <div className="App">
        <Legal currentUser={currentUser} currentLegal={currentLegal} acceptLegal={this.acceptLegal} />
        <Switch>
          <Route exact path="/" component={this.props.isTherapist ? PatientLayout : PatientSingleLayout} />
          <Route exact path="/rider" component={PatientLayout}/>

          <Route exact path="/rider/:id/overview" render={(props) => <PatientSingleLayout {...props} tabIndex={0} tab="overview" />}/>
          <Route exact path="/rider/:id/allcore360" render={(props) => <PatientSingleLayout {...props} tabIndex={1} tab="allcore360" />}/>
          <Route exact path="/rider/:id/run-ride" render={(props) => <PatientSingleLayout {...props} tabIndex={2} tab="run-ride" />}/>
          <Route exact path="/rider/:id/notes" render={(props) => <PatientSingleLayout {...props} tabIndex={3} tab="notes" />}/>
          <Route exact path="/rider/:id/profile" render={(props) => <PatientSingleLayout {...props} tabIndex={4} tab="profile" />}/>

          <Route exact path="/settings" component={SettingsLayout}/>
          <Route exact path="/reports" component={ReportsLayout}/>
          <Route exact path="/reports/rides" component={ReportsRideDataLayout}/>
          <Route exact path="/reports/leaderboards" component={LeaderboardLayout}/>
        </Switch>
        { this.props.isTherapist && <TabBar /> }
        <SnackBar />
        { this.props.announcements.length > 0 && <AnnouncementLayout /> }
      </div>
    )
  }
}

export default compose(
  withRouter,
  withReactGA(process.env.REACT_APP_MANAGE_GA_ID),
  connect(mapStateToProps, mapDispatchToProps),
)(App)
